/* eslint-disable no-irregular-whitespace */
<template>
  <div class="p-menu mb-16 mt-px sm:mb-0">
    <ModalError :visible="showModalError" :errorType="errorType" ></ModalError>
    <div class="menu-main-content">
      <div v-if="isMenuPublicDate" class="no-data">
        <p>有効なメニュー・プランがございませんでした。</p>
      </div>
      <div v-else class="c-box">
        <section class="sm:hidden" v-if="tag">
          <div class="main-top">
            <div class="main-top-left" v-if="false">
              <div class="item">
                <Rating :rate="rate.rateAvg" />
              </div>
              <div class="item">
                <div class="comment">
                  <i class="icon icon-bor-bubble" />
                </div>
                <span class="count">{{ commentCount | formatInteger }}</span>
              </div>
              <div class="item">
                <div class="like">
                  <i class="icon icon-bor-heart" />
                </div>
                <span class="count">{{ favoriteCount | formatInteger }}</span>
              </div>
            </div>
            <div class="main-top-right">
              <div
                class="label label-grey-200"
                v-for="(tag, index) in menuIcons"
                :key="`tag-${index}`"
              >
                {{ tag.iconNm }}
              </div>
            </div>
          </div>
        </section>
        <Header class="pb-3" v-model="menuBasicInfo" />
        <a-divider> </a-divider>

        <div class="mobile-view hidden sm:block">
          <ImageScroller v-if="menuImages && menuImages.length > 1" :fullwidth="true" :images="menuImages" wrapper-class="mb-5" />
          <FluidImage v-if="menuImages && menuImages.length === 1" :src="menuImages[0].imageUrl" :alt="menuImages[0].imageExplanation" wrapper-class="mb-5" />
          <DashTitle v-if="menuBasicInfo && menuBasicInfo.catchCopy" :text="menuBasicInfo.catchCopy" />
          <div class="text-primary mb-6">
            <p
              v-if="menuBasicInfo && leadCopy"
              class="whitespace-pre-wrap mt-0 mb-0 font-size13"
              v-html="menuBasicInfo.leadCopy"
              v-show="menuBasicInfo && menuBasicInfo.leadCopy"
            ></p>
          </div>
          <PrimaryButton 
            v-show="isLoading" 
            text="申し込む"
            @click="onNextOrder" 
            wrapper-class="mb-8" 
            :disabled="!availableSubsidy"/>
          <hr class="std-line-breaker" />

          <!-- 補助金 リスト-->
          <div
            class="box-coupons"
            v-show="availableSubsidy"
          >
            <div class="box-coupons-left text-center">
              <i class="icon icon-bor-coupons text-primary" />
              <p class="lg:block">補助クーポン</p>
              <p>利用可能</p>
            </div>
            <a-divider type="vertical" class="coupon-divider" />
            <div class="coupons-contents">
              <!-- グループ補助金： グループ補助金の上部にグループ補助金情報を表示 -->
              <div class="hidden sm:block"
                v-for="(groupSubsidy, gIndex) in subsidyCouponGroupList"
                :key="`subsidy-${groupSubsidy.availableData.subsidyDetailId}-sm`"
                v-show="gIndex === 0 || expandCouponList == true"
              >
                <template v-if="groupSubsidy.availableData.groupInfo != null && groupSubsidy.displayGroupInfoFlg">
                  <div v-show="groupSubsidy.dispFlag || expandCouponList == true" class="coupon-card">
                    <!-- グループ補助金名称 -->
                    <div
                      class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center"
                    >
                      <strong class="py-0.5">{{ groupSubsidy.availableData.groupInfo.groupName }}</strong>
                    </div>
                    <!-- グループ補助金：保有枚数 -->
                    <!-- 利用制限単位（usedLimUnit）が[02：契約ID毎][03：契約ID合計毎]の場合、非表示とする -->
                    <div
                      v-if="groupSubsidy.availableData.usedLimUnit != '02' && groupSubsidy.availableData.usedLimUnit != '03'
                          && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value !== null"
                    >
                      <span>保有枚数&nbsp;</span>
                      <!-- 上限枚数と残枚数が設定されている場合：「X/Y枚」 -->
                      <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt !== null">
                        {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                        /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt | formatInteger}}
                        枚
                      </div>
                      <!-- 上限枚数未設定かつ残枚数が設定されている場合：「X枚」 -->
                      <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt == null">
                        {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                        枚
                      </div>
                    </div>
                    <!-- グループ補助金：利用可能残金額 -->
                    <div
                      v-if="groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value !== null"
                    >
                      <span>利用可能残金額&nbsp;</span>
                      <!-- 上限金額と残金が設定されている場合：「X/Y円」 -->
                      <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt !== null">
                        {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                        /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt | formatInteger}}
                        円
                      </div>
                      <!-- 上限金額が未設定かつ残金が設定されている場合：「X円」 -->
                      <div v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt == null">
                        {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                        円
                      </div>
                    </div>
                    <!-- グループ補助金：申込期間 -->
                    <p
                      v-if="
                        groupSubsidy.availableData.groupInfo.receptionDateFrom != null ||
                        groupSubsidy.availableData.groupInfo.receptionDateTo != null
                      "
                    >
                      申込期間（受付期間）
                      <span v-if="groupSubsidy.availableData.groupInfo.receptionDateFrom != null">
                        {{ $moment(groupSubsidy.availableData.groupInfo.receptionDateFrom).format('YYYY/MM/DD') }}
                      </span>
                      <span v-if="groupSubsidy.availableData.groupInfo.receptionDateTo != null">
                        ～{{$moment(groupSubsidy.availableData.groupInfo.receptionDateTo).format('YYYY/MM/DD') }}
                      </span>
                    </p>
                    <!-- グループ補助金内容説明 -->
                    <div v-if="infoGroupTexts(groupSubsidy)" v-html="infoGroupTexts(groupSubsidy)" />
                    <!-- グループ補助金用のWeb注記コメント -->
                    <div>{{ groupSubsidy.availableData.groupInfo.dispNoteComment }}</div>
                    <!-- グループに紐づく補助金表示 -->
                    <!-- 再度ループして、上階層ループのグループIDと同一のものを表示する -->
                    <div
                      v-for="(subsidy) in subsidyCouponGroupList"
                      :key="`subsidy-${subsidy.availableData.subsidyDetailId}-sm`"
                    >
                      <div
                        v-if="subsidy.availableData.groupInfo.groupId == groupSubsidy.availableData.groupInfo.groupId"
                        v-show="gIndex === 0 || expandCouponList == true"
                      >
                        <details class="accordion-wrapper ">
                          <summary class="name-coupon font-size-medium accordion-summary ">
                            <span>
                              <strong class="py-0.5">{{ getNestedValue(subsidy, 'availableData.dispSubsidyNm') }}</strong>
                            </span>
                          </summary>
                          <div v-if="subsidy.availableData.groupInfo.groupId == groupSubsidy.availableData.groupInfo.groupId">
                            <!-- 1. -->
                            <div v-if="getNestedValue(subsidy, 'listPrice')">
                              補助単価 
                              <div v-for="(couponsItem, idx) in getNestedValue(subsidy, 'listPrice')" :key="idx">
                                {{ couponsItem.ageType }} {{ couponsItem.price | formatCurrency('円') }}
                                <div v-if=" couponsItem.limApplicableDateFrom || couponsItem.limApplicableDateTo ">
                                  有効期限 
                                  <span v-if="couponsItem.limApplicableDateFrom">
                                    {{
                                      couponsItem.limApplicableDateFrom
                                    }}
                                  </span>
                                  <span v-if="couponsItem.limApplicableDateTo">
                                    ~{{ couponsItem.limApplicableDateTo }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <p>
                              ※宿泊日によって補助金額が異なる場合があります。詳細はマイページをご確認下さい。
                            </p>
                            <template v-if="getRequestTypeCoupon(subsidy) == '01'">
                              <div v-if="isShowParsonalUsedMaxCnt(subsidy)">
                                保有枚数 {{ subsidy.availableRemainingCount | formatInteger }}/{{
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt')
                                    | formatInteger
                                }}枚<br>
                                利用可能残金額 {{
                                  subsidy.availableRemainingAmount | formatInteger
                                }}/{{
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                                    | formatInteger
                                }}円
                              </div>

                              <div
                                v-if="
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt') > 0 &&
                                  !getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                                "
                              >
                                保有枚数 {{ subsidy.availableRemainingCount | formatInteger }}/{{
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt')
                                    | formatInteger
                                }}枚
                              </div>

                              <div
                                v-if="
                                  !getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt') &&
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt') >
                                    0
                                "
                              >
                                利用可能残金額 {{
                                  subsidy.availableRemainingAmount | formatInteger
                                }}/{{
                                  getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                                    | formatInteger
                                }}円
                              </div>
                            </template>
                            <p
                              v-if="
                                getNestedValue(subsidy, 'availableData.receptionDateFrom') ||
                                getNestedValue(subsidy, 'availableData.receptionDateTo')
                              "
                            >
                              申込期間（受付期間）
                              <span
                                v-if="getNestedValue(subsidy, 'availableData.receptionDateFrom')"
                              >
                                {{
                                  getNestedValue(subsidy, 'availableData.receptionDateFrom')
                                }}</span
                              >
                              <span v-if="getNestedValue(subsidy, 'availableData.receptionDateTo')"
                                >～{{
                                  getNestedValue(subsidy, 'availableData.receptionDateTo')
                                }}</span
                              >
                            </p>

                            <!-- 利用制限期間（年） -->
                            <p class="planDetail" v-if="getNestedValue(subsidy, 'availableData.usedLimTerm') == '01'">
                              上記適用期間内での制限適用となります
                            </p>
                            <!-- 利用制限期間（月） -->
                            <p class="planDetail" v-if="getNestedValue(subsidy, 'availableData.usedLimTerm') == '02'">
                              月の利用制限となります
                            </p>

                            <template v-if="getRequestTypeCoupon(subsidy) == '02'">
                              <div v-if="isShowUsedMaxCntInsurance01(subsidy) > 0 && !isShowUsedMaxTotalAmt(subsidy)">
                                第{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.applicableDegreeCnt'
                                  ) | formatInteger
                                }}親等までを対象者として、1対象者あたり最大{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.parsonalUsedMaxCnt' 
                                  ) | formatInteger
                                }}枚までご利用いただけます
                              </div>
                              <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && !isShowUsedMaxCntInsurance01(subsidy)">
                                第{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.applicableDegreeCnt'
                                  ) | formatInteger
                                }}親等までを対象者として、1対象者あたり最大{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.parsonalUsedMaxTotalAmt'
                                  ) | formatInteger
                                }}円までご利用いただけます
                              </div>
                              <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && isShowUsedMaxCntInsurance01(subsidy) > 0">
                                第{{
                                  getNestedValue(subsidy, 'availableData.applicableDegreeCnt')
                                    | formatInteger
                                }}親等までを対象者として、1対象者あたり最大{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.applicableDegreeCnt'
                                  ) | formatInteger
                                }}枚、{{
                                  getNestedValue(
                                    subsidy,
                                    'availableData.parsonalUsedMaxTotalAmt'
                                  ) | formatInteger
                                }}円までご利用いただけます
                              </div>
                              <div v-if="isShowRemainingAmtCntLabelInsur(subsidy)">
                                下記は、過去に利用した対象者の保有枚数（残金額）を表示しています。
                                未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                                {{
                                  getNestedValue(
                                    subsidy,
                                    'scrennDisplayItemList.remainingAmountLabel'
                                  ) | formatInteger
                                }}
                              </div>
                              <div
                                v-if="
                                  getNestedValue(
                                    subsidy,
                                    'scrennDisplayItemList.remainingCountLabel'
                                  )
                                "
                              >
                                下記は、過去に利用した対象者の保有枚数を表示しています。
                                未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                                {{
                                  getNestedValue(
                                    subsidy,
                                    'scrennDisplayItemList.remainingCountLabel'
                                  ) | formatInteger
                                }}
                              </div>
                            </template>

                            <!-- <div v-else> 項目非表示 </div> -->
                            <!-- usedMaxCnt -->
                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.usedMaxCnt')"
                            >
                              所属団体様内で先着{{
                                getNestedValue(subsidy, 'availableData.usedMaxCnt') | formatInteger
                              }}枚まで
                            </p>

                            <!-- usedMaxTotalAmt -->
                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.usedMaxTotalAmt')"
                            >
                              ※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。
                            </p>

                            <!-- minChargeAmt -->
                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.minChargeAmt') === 1"
                            >
                              必ず自己負担が必要になります。
                            </p>

                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.minChargeAmt') > 1"
                            >
                              {{
                                getNestedValue(subsidy, 'availableData.minChargeAmt')
                              }}円以上のご負担が必要となります。
                            </p>
                            <!-- <p v-if="!getNestedValue(subsidy, 'availableData.minChargeAmt')">項目非表示</p> -->
                            <!-- 実費未満投入可否 -->
                            <template>
                              <p
                                class="planDetail"
                                v-if="
                                  !getNestedValue(subsidy, 'availableData.minChargeAmt') &&
                                  getNestedValue(subsidy, 'availableData.costUnderChargeableFlg') ==
                                    '0'
                                "
                              >
                                利用金額が補助金額に満たない場合は利用不可
                              </p>
                            </template>

                            <!-- 重複可否 -->

                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.minTgtAge')"
                            >
                              {{
                                getNestedValue(subsidy, 'availableData.minTgtAge') | formatInteger
                              }}歳以上が対象
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                getNestedValue(subsidy, 'availableData.personAccompanyFlg') === '1'
                              "
                            >
                              家族会員のみでの利用不可
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                getNestedValue(subsidy, 'availableData.multipleUnusableFlg') === '0'
                              "
                            >
                              併用可
                            </p>
                            <p
                              class="planDetail"
                              v-if="
                                getNestedValue(subsidy, 'availableData.multipleUnusableFlg') === '1'
                              "
                            >
                              併用不可
                            </p>
                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.usedFormDiv') === '01'"
                            >
                              対象メニューの申込で自動で利用できます
                            </p>
                            <p
                              class="planDetail"
                              v-if="getNestedValue(subsidy, 'availableData.usedFormDiv') === '02'"
                            >
                              利用申請があった場合のみ利用できます
                            </p>
                            <p>
                              {{ subsidy.availableData.dispNoteComment }}
                            </p>
                            <div class="mb-2"></div>
                          </div>
                        </details>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <!-- グループ補助金以外 -->
              <div class="hidden sm:block"
                v-for="(subsidy, index) in subsidyCouponList"
                :key="`subsidy-${subsidy.availableData.subsidyDetailId}-sm`"
                v-show="(subsidyCouponGroupList.length == 0 && index === 0) || expandCouponList == true"
              >
                <div
                  class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center"
                >
                  <strong class="py-0.5">{{
                    getNestedValue(subsidy, 'availableData.dispSubsidyNm')
                  }}</strong>
                </div>
                <!-- 1. -->
                <div v-if="getNestedValue(subsidy, 'listPrice')">
                  補助単価 
                  <div v-for="(couponsItem, idx) in getNestedValue(subsidy, 'listPrice')" :key="idx">
                    {{ couponsItem.ageType }} {{ couponsItem.price | formatCurrency('円') }}
                    <div v-if=" couponsItem.limApplicableDateFrom || couponsItem.limApplicableDateTo ">
                      有効期限 
                      <span v-if="couponsItem.limApplicableDateFrom">
                        {{
                          couponsItem.limApplicableDateFrom
                        }}
                      </span>
                      <span v-if="couponsItem.limApplicableDateTo">
                        ~{{ couponsItem.limApplicableDateTo }}
                      </span>
                    </div>
                  </div>
                </div>
                <p>
                  ※宿泊日によって補助金額が異なる場合があります。詳細はマイページをご確認下さい。
                </p>
                <template v-if="getRequestTypeCoupon(subsidy) == '01'">
                  <div v-if="isShowParsonalUsedMaxCnt(subsidy)">
                    保有枚数 {{ subsidy.availableRemainingCount | formatInteger }}/{{
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt')
                        | formatInteger
                    }}枚<br>
                    利用可能残金額 {{
                      subsidy.availableRemainingAmount | formatInteger
                    }}/{{
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                        | formatInteger
                    }}円
                  </div>

                  <div
                    v-if="
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt') > 0 &&
                      !getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                    "
                  >
                    保有枚数 {{ subsidy.availableRemainingCount | formatInteger }}/{{
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt')
                        | formatInteger
                    }}枚
                  </div>

                  <div
                    v-if="
                      !getNestedValue(subsidy, 'availableData.parsonalUsedMaxCnt') &&
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt') >
                        0
                    "
                  >
                    利用可能残金額 {{
                      subsidy.availableRemainingAmount | formatInteger
                    }}/{{
                      getNestedValue(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
                        | formatInteger
                    }}円
                  </div>
                </template>
                <p
                  v-if="
                    getNestedValue(subsidy, 'availableData.receptionDateFrom') ||
                    getNestedValue(subsidy, 'availableData.receptionDateTo')
                  "
                >
                  申込期間（受付期間）
                  <span
                    v-if="getNestedValue(subsidy, 'availableData.receptionDateFrom')"
                  >
                    {{
                      getNestedValue(subsidy, 'availableData.receptionDateFrom')
                    }}</span
                  >
                  <span v-if="getNestedValue(subsidy, 'availableData.receptionDateTo')"
                    >～{{
                      getNestedValue(subsidy, 'availableData.receptionDateTo')
                    }}</span
                  >
                </p>

                <!-- 利用制限期間（年） -->
                <p class="planDetail" v-if="getNestedValue(subsidy, 'availableData.usedLimTerm') == '01'">
                  上記適用期間内での制限適用となります
                </p>
                <!-- 利用制限期間（月） -->
                <p class="planDetail" v-if="getNestedValue(subsidy, 'availableData.usedLimTerm') == '02'">
                  月の利用制限となります
                </p>

                <template v-if="getRequestTypeCoupon(subsidy) == '02'">
                  <div v-if="isShowUsedMaxCntInsurance01(subsidy) > 0 && !isShowUsedMaxTotalAmt(subsidy)">
                    第{{
                      getNestedValue(
                        subsidy,
                        'availableData.applicableDegreeCnt'
                      ) | formatInteger
                    }}親等までを対象者として、1対象者あたり最大{{
                      getNestedValue(
                        subsidy,
                        'availableData.parsonalUsedMaxCnt' 
                      ) | formatInteger
                    }}枚までご利用いただけます
                  </div>
                  <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && !isShowUsedMaxCntInsurance01(subsidy)">
                    第{{
                      getNestedValue(
                        subsidy,
                        'availableData.applicableDegreeCnt'
                      ) | formatInteger
                    }}親等までを対象者として、1対象者あたり最大{{
                      getNestedValue(
                        subsidy,
                        'availableData.parsonalUsedMaxTotalAmt'
                      ) | formatInteger
                    }}円までご利用いただけます
                  </div>
                  <div v-if="isShowUsedMaxTotalAmt(subsidy) > 0 && isShowUsedMaxCntInsurance01(subsidy) > 0">
                    第{{
                      getNestedValue(subsidy, 'availableData.applicableDegreeCnt')
                        | formatInteger
                    }}親等までを対象者として、1対象者あたり最大{{
                      getNestedValue(
                        subsidy,
                        'availableData.applicableDegreeCnt'
                      ) | formatInteger
                    }}枚、{{
                      getNestedValue(
                        subsidy,
                        'availableData.parsonalUsedMaxTotalAmt'
                      ) | formatInteger
                    }}円までご利用いただけます
                  </div>
                  <div v-if="isShowRemainingAmtCntLabelInsur(subsidy)">
                    下記は、過去に利用した対象者の保有枚数（残金額）を表示しています。
                    未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                    {{
                      getNestedValue(
                        subsidy,
                        'scrennDisplayItemList.remainingAmountLabel'
                      ) | formatInteger
                    }}
                  </div>
                  <div
                    v-if="
                      getNestedValue(
                        subsidy,
                        'scrennDisplayItemList.remainingCountLabel'
                      )
                    "
                  >
                    下記は、過去に利用した対象者の保有枚数を表示しています。
                    未使用の方の保有枚数は記載しておりませんが、適用対象者として申請できます。<br />
                    {{
                      getNestedValue(
                        subsidy,
                        'scrennDisplayItemList.remainingCountLabel'
                      ) | formatInteger
                    }}
                  </div>
                </template>

                <!-- <div v-else> 項目非表示 </div> -->
                <!-- usedMaxCnt -->
                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.usedMaxCnt')"
                >
                  所属団体様内で先着{{
                    getNestedValue(subsidy, 'availableData.usedMaxCnt') | formatInteger
                  }}枚まで
                </p>

                <!-- usedMaxTotalAmt -->
                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.usedMaxTotalAmt')"
                >
                  ※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。
                </p>

                <!-- minChargeAmt -->
                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.minChargeAmt') === 1"
                >
                  必ず自己負担が必要になります。
                </p>

                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.minChargeAmt') > 1"
                >
                  {{
                    getNestedValue(subsidy, 'availableData.minChargeAmt')
                  }}円以上のご負担が必要となります。
                </p>
                <!-- <p v-if="!getNestedValue(subsidy, 'availableData.minChargeAmt')">項目非表示</p> -->
                <!-- 実費未満投入可否 -->
                <template>
                  <p
                    class="planDetail"
                    v-if="
                      !getNestedValue(subsidy, 'availableData.minChargeAmt') &&
                      getNestedValue(subsidy, 'availableData.costUnderChargeableFlg') ==
                        '0'
                    "
                  >
                    利用金額が補助金額に満たない場合は利用不可
                  </p>
                </template>

                <!-- 重複可否 -->

                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.minTgtAge')"
                >
                  {{
                    getNestedValue(subsidy, 'availableData.minTgtAge') | formatInteger
                  }}歳以上が対象
                </p>
                <p
                  class="planDetail"
                  v-if="
                    getNestedValue(subsidy, 'availableData.personAccompanyFlg') === '1'
                  "
                >
                  家族会員のみでの利用不可
                </p>
                <p
                  class="planDetail"
                  v-if="
                    getNestedValue(subsidy, 'availableData.multipleUnusableFlg') === '0'
                  "
                >
                  併用可
                </p>
                <p
                  class="planDetail"
                  v-if="
                    getNestedValue(subsidy, 'availableData.multipleUnusableFlg') === '1'
                  "
                >
                  併用不可
                </p>
                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.usedFormDiv') === '01'"
                >
                  対象メニューの申込で自動で利用できます
                </p>
                <p
                  class="planDetail"
                  v-if="getNestedValue(subsidy, 'availableData.usedFormDiv') === '02'"
                >
                  利用申請があった場合のみ利用できます
                </p>
                <p>
                  {{ subsidy.availableData.dispNoteComment }}
                </p>
                <div class="mb-2"></div>
              </div>
              <div
                class="expand-icon"
                @click="expandCouponList = !expandCouponList"
                v-show="subsidyList && subsidyList.length > 1"
              >
                {{
                  expandCouponList
                    ? '閉じる'
                    : `他${subsidyCouponList.length + subsidyGroupList.length - 1}種の補助クーポンがあります`
                }}<i
                  class="icon icon-bor-triangle-down"
                  :class="expandCouponList ? 'rotate' : ''"
                />
              </div>
            </div>
          </div>
          <hr class="std-line-breaker" />

          <div class="service-section box" v-if="menuInformation">
            <DashTitle text="インフォメーション" />
            <TextHeightCutter :height="98" wrapper-class="content font-size13">
              <ul class="plain-list-style">
                  <li v-for="(menu, index) in menuInformation" :key="`memuInfo-${index}`">
                    <h5 v-if="menu.title" class="mb-4">{{ menu.title }}</h5>
                    <p v-if="menu.content" class="mb-3">
                      {{ menu.content }}
                    </p>
                    <a class="blue" :href="`${menu.linkUrl}`">{{ menu.linkNm ? menu.linkNm : menu.linkUrl }}</a>
                  </li>
                </ul>
            </TextHeightCutter>
            <hr class="std-line-breaker" />
          </div>

          <div class="font-size13 mb-6">［注意事項］店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。</div>
          <hr class="std-line-breaker" />

          <GoogleMapIframe :latitude="latitude" :longitude="longitude" :height="236" />
          <RightArrowText wrapper-class="sm:flex" @click="openMap" text="Google Mapで見る" />

          <div v-if="facilities" class="main-detail-equipments">
            <GrayPanel v-if="facilities.facilityAddress" title="住所" :content="`〒${zipCode} ${facilities.facilityAddress}`" />
            <GrayPanel title="住所" :content="facilities.access ? facilities.access : '-'" />
            <GrayPanel title="駐車場" :content="canUseParking ? 'あり' : 'なし'" />
            <GrayPanel title="TEL" :content="facilities.facilityTelNo ? facilities.facilityTelNo : '-'" />
            <GrayPanel title="メール" :content="facilities.facilityEmail ? facilities.facilityEmail : '-'" />
            <GrayPanel title="URL">
              <template v-if="facilities.facilityUrl">
                <a :href="facilities.facilityUrl ? facilities.facilityUrl : '#'" target="_blank">{{facilities.facilityUrl}}</a>
              </template>
              <template v-else>-</template>   
            </GrayPanel>
          </div>          

        </div>

        <!-- /* Carousel */ -->
        <section class="lg:pl-4 pt-3 sm:hidden">
          <div class="main-demo">
            <div class="menu-carousel">
              
              <BasicCarousel
                class="mb-4 lg:hidden"
                :images="menuImages"
                :isShowIndicator="false"
              />

              <div
                class="slide-images-mobile hidden lg:flex overflow-x-auto"
                v-if="menuImages"
              >
                <div :class="menuImages.length === 1 ? 'img-slide-one' : 'img-slide'">
                  <img
                    v-for="(item, index) in menuImages"
                    :key="`menuImages-${index}`"
                    :src="`${item.imageUrl}`"
                    :alt="`${item.imageExplanation}`"
                  />
                </div>
              </div>
            </div>

            <div class="menu-calendar">
              <div class="main-information">
                <div class="box-content" v-if="menuBasicInfo">
                  <h3 v-if="catchCopy">
                    {{ menuBasicInfo.catchCopy }}
                  </h3>
                  <p
                    v-if="leadCopy"
                    class="whitespace-pre-wrap"
                    v-html="menuBasicInfo.leadCopy"
                    v-show="menuBasicInfo && menuBasicInfo.leadCopy"
                  ></p>
                </div>
                <div class="main-information-refer lg:flex-wrap">
                  <!-- <div class="label w-15 label-lg lg:w-full lg:mb-2 justify-center lg:justify-start">
                    
                  </div> -->
                  <div class="list-links" v-if="menuHashtags && menuHashtags.freeWord">
                    <a href="#">#{{ menuHashtags.freeWord }}</a>
                  </div>
                  <!-- <div class="list-links">
                    <a href="#">#123456</a>
                  </div> -->
                </div>
              </div>
              <a-button v-show="isLoading"
                class="btn-dark c-btn btn-reserve w-full"
                size="large"
                @click="onNextOrder"
                :disabled="!availableSubsidy"
                >申し込み</a-button
              >
              <!-- 補助金 リスト-->
              <div
                class="box-coupons"
                v-show="availableSubsidy"
              >
                <div class="box-coupons-left text-center">
                  <i class="icon icon-bor-coupons text-primary" />
                  <p class="lg:block">補助クーポン</p>
                  <p>利用可能</p>
                </div>
                <a-divider type="vertical" class="coupon-divider" />
                <div class="coupons-contents">
                  <SubsidyGroupDetail class="sm:hidden"
                    :subsidy="subsidyCouponGroupList"
                    :subsidyShow="expandCouponList == true"
                  />
                  <SubsidyDetail class="sm:hidden"
                    v-for="(subsidy, index) in subsidyCouponList"
                    :key="`subsidy-${subsidy.availableData.subsidyDetailId}`"
                    :subsidy="subsidy"
                    v-show="(subsidyCouponGroupList.length == 0 && index === 0) || expandCouponList == true"
                  />
                  <div
                    class="expand-icon"
                    @click="expandCouponList = !expandCouponList"
                    v-show="subsidyList && (subsidyCouponList.length + subsidyGroupList.length) > 1"
                  >
                    {{
                      expandCouponList
                        ? '閉じる'
                        : `他${subsidyCouponList.length + subsidyGroupList.length - 1}種の補助クーポンがあります`
                    }}<i
                      class="icon icon-bor-triangle-down"
                      :class="expandCouponList ? 'rotate' : ''"
                    />
                  </div>
                </div>
              </div>
              <div class="pt-4" v-if="!loggedIn">
                ご加入コース・団体によっては、ご利用いただけない場合がございます。<br />
                予めご了承ください。
              </div>
            </div>
          </div>
        </section>
        <!-- Information -->

        <!-- Viewmore -->
        <section class="sm:hidden" v-if="menuInformation">
          <SectionContentTitle
            :lineType="lineType.vertical"
            titleContent="インフォメーション"
          />
          <div
            class="main-description"
            v-for="(menu, index) in menuInformation"
            :key="`memuInfo-${index}`"
          >
            <BoxViewMore>
              <h3 v-show="menu.title">{{ menu.title }}</h3>
              <p
                class="whitespace-pre-wrap mb-3"
                v-html="menu.content"
                style="min-height: 15px"
              ></p>
              <a class="blue" :href="`${menu.linkUrl}`">{{
                menu.linkNm ? menu.linkNm : menu.linkUrl
              }}</a>
            </BoxViewMore>
          </div>
        </section>

        <!-- Map -->
        <section class="sm:hidden">
          <div class="main-detail" ref="googleMap">
            <div class="main-map">
              <iframe
                width="100%"
                height="500"
                style="border: 0"
                loading="lazy"
                allowfullscreen
                :src="`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_KEY}&q=${latitude},${longitude}&center=${latitude + mapCenter},${longitude}`"
              >
              </iframe>

              <div class="flex justify-end mt-2">
                <a @click="openMap" target="_blank">
                  <span class="text-black">Google Mapで見る</span>
                  <i class="icon icon-bor-arrow-right text-primary pl-2" />
                </a>
              </div>
            </div>
            <div class="divider my-6" />
            <div class="main-detail-information">
              <div class="item-detail-label w-full">
                <div class="label label-lg label-grey-200">住所</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityAddress"
                >
                  〒{{ zipCode }} {{ facilities.facilityAddress }}
                </div>
              </div>
              <div class="item-detail-label w-full">
                <div class="label label-lg label-grey-200">アクセス</div>
                <div class="item-detail-content" v-if="facilities && facilities.access">
                  {{ facilities.access }}
                </div>
              </div>
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">駐車場</div>
                <div class="item-detail-content">
                  <span v-if="canUseParking">あり</span>
                  <span v-else>なし</span>
                </div>
              </div>
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">無料送迎</div>
                <div class="item-detail-content">
                  <span v-if="canUseFreeTransfer">あり</span>
                  <span v-else>なし</span>
                </div>
              </div>
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">TEL</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityTelNo"
                >
                  {{ facilities.facilityTelNo }}
                </div>
              </div>
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">FAX</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityFax"
                >
                  <div class="item-line">
                    {{ facilities.facilityFax }}
                  </div>
                </div>
              </div>
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">メール</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityEmail"
                >
                  {{ facilities.facilityEmail }}
                </div>
              </div>
              <!-- <div class="item-detail-label">
                <div class="label label-lg label-grey-200">お問い合わせ</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityInqForm"
                >
                  {{ facilities.facilityInqForm }}
                  <a :href="`${facilities.facilityInqForm}`" target="_blank"
                    ><i class="ml-2 icon icon-bor-full-screen"
                  /></a>
                </div>
              </div> -->
              <div class="item-detail-label">
                <div class="label label-lg label-grey-200">URL</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.facilityUrl"
                >
                  {{ facilities.facilityUrl }}
                </div>
              </div>
              <!-- <div class="item-detail-label">
                <div class="label label-lg label-grey-200">公式アカウント</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.snsOfclAccts"
                >
                  <p class="flex items-center">
                    <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                      <img src="@/assets/images/Instagram.png" alt="icon" />
                    </a>
                    <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                      <i class="icon icon-bor-twitter text-xl" />
                    </a>
                    <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                      <i class="icon icon-bor-facebook text-xl" />
                    </a>
                  </p>
                </div>
              </div> -->
              <!-- <div class="item-detail-label">
                <div class="label label-lg label-grey-200">定休日</div>
                <div
                  class="item-detail-content"
                  v-if="
                    facilities &&
                    Array.isArray(facilities.regularlyCloseds) &&
                    facilities.regularlyCloseds.length > 0
                  "
                >
                  {{ facilities.regularlyCloseds[0] }}
                </div>
              </div> -->
              <!-- <div class="item-detail-label">
                <div class="label label-lg label-grey-200">特典</div>
                <div
                  class="item-detail-content"
                  v-if="facilities && facilities.equipServices"
                >
                  {{ facilities.equipServices }}
                </div>
              </div> -->
            </div>
            <div class="divider mb-8 lg:mb-6 mt-0 sm:hidden" />
            <div class="main-footer sm:hidden">
              <p class="mb-2 text-black">
                ［注意事項］
                店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
              </p>
            </div>
          </div>
        </section>
      </div>

      <!-- Recommended -->
      <section class="mb-12 mt-8 p-0 sm:hidden" v-if="aroundServices && aroundServices.length">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="周辺のおすすめサービス"
        />
        <div class="list-recommended-services">
          <RecommendedItem
            v-for="(item, index) in aroundServices.slice(0, 4)"
            :key="`recommended-${index}`"
            :recommended_data="item"
          />
        </div>
      </section>

      <section
        class="mb-12 mt-8 p-0 sm:hidden"
        v-if="menuCategoryTag && sameCategoryMenus && sameCategoryMenus.length"
      >
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="同じカテゴリのサービス"
        />
        <div class="list-recommended-services">
          <RecommendedItem
            v-for="(item, index) in sameCategoryMenus.slice(0, 4)"
            :key="`recommended-${index}`"
            :recommended_data="item"
          />
        </div>
      </section>

      <!-- <section class="mb-20 p-0 lg:pl-5">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="おすすめの特集・イベント"
        />
        <CarouselEvents :img="dataImg" />
      </section> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import moment from 'moment'
import _ from 'lodash'
import { get, isEmpty, minBy } from 'lodash'
import { bus } from '@/main'

import {
  // HotelItem,
  // CarouselThumbnail,
  // CarouselEvents,
  BoxViewMore,
  SectionContentTitle,
  ImageScroller,
  FluidImage,
  PrimaryButton,
  TextLineCutter,
  DashTitle,
  RightArrowText,
  GoogleMapIframe,
  GrayPanel,
  TextHeightCutter
} from '@/components/compound'
import ListPlanItem from '../components/ListPlanItem'
import { Rating } from '@/components/primitive'
import {
  GET_MENU_BASIC_INFO,
  GET_MENU_STAY,
  GET_SAME_CATEGORY_MENUS,
  GET_FACILITIES
} from '@/store/modules/menu/actions.js'
import RecommendedItem from './RecommendedItem'
import func_utils from '@/mixins/func_utils'
import Header from './../Header'
import SubsidyDetail from '../components/SubsidyDetail';
import SubsidyGroupDetail from '../components/SubsidyGroupDetail';
import { COUPON_PRICE_TYPE } from '@/constants/coupon'
import { SAVE_CUSTOMER_PLAN, SAVE_PLAN_DETAIL} from '@/store/modules/plan/actions'
import { SAVE_PUBLIC_STAY, SAVE_SELECTED_WEB_RADIO} from '@/store/modules/bs_app/actions'
import { GET_SERVICE_DETAIL } from '@/store/modules/service/actions.js'
export default {
  mixins: [func_utils],
  components: {
    // CarouselThumbnail,
    Rating,
    // HotelItem,
    RecommendedItem,
    BoxViewMore,
    SectionContentTitle,
    ListPlanItem,
    Header,
    ImageScroller,
    FluidImage,
    PrimaryButton,
    TextLineCutter,
    DashTitle,
    RightArrowText,
    GoogleMapIframe,
    GrayPanel,
    TextHeightCutter,
    SubsidyDetail,
    SubsidyGroupDetail,
  },

  data() {
    return {
      isLoading: false,
      showModalError: false,
      errorType: '',
      open: false,
      menuBasicInfo: null,
      vacancyCalendar: {
        vacancyCalendars: []
      },
      menuIcons: [],
      menuImages: [],
      menuHashtags: null,
      photoGallery: null,
      plans: [],
      facilities: null,
      equipServices: [],
      serviceAreas: null,
      rate: {
        rateAvg: 4.5
      },
      favoriteCount: 1234,
      commentCount: 5353535,
      minPrice: 0,
      menuStatus: null,
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      dateFormat: 'YYYY/MM/DD',
      instockDayMap: {},
      fewLeftDayMap: {},
      outstockDayMap: {},
      stayDay: moment(new Date()),
      equipmentServices: [],
      sameCategoryMenus: [],
      latitude: 0,
      longitude: 0,
      GOOGLE_MAP_KEY: 'AIzaSyDYDgespYtyMc8ELnoEnw8sWb80xxDNJHg',
      aroundServices: [],
      zipCode: '',
      paginationPlan: {
        page: 1,
        size: 10,
        totalItems: 0
      },
      planList: [],
      numPeople: 1,
      stayNights: 1,
      checkInDay: null,
      checkOutDay: moment().add(1, 'days'),
      menuInformation: null,
      pblcBenefitsInfo: null,
      catchCopy: null,
      leadCopy: null,
      canUseParking: false,
      canUseFreeTransfer: false,
      validateMenuWithUser: true,
      isMenuPublicDate: null,
      subsidyList: [],
      subsidyCouponList: [],
      subsidyCouponGroupList: [],
      subsidyGroupList: [],
      expandCouponList: false
    }
  },

  computed: {
    currentDay() {
      return moment().format('YYYY/MM/DD')
    },

    getMenuDetailInfo() {
      return _.cloneDeep(this.getNestedValue(this.$store.state, 'menu.menuDetail', null))
    },

    loggedIn() {
      return this.$auth.loggedIn
    },

    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },

    filterOpenDays() {
      this.instockDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 4 || e.stock === 0)
      const instockDays = []
      vacancyCalendars.forEach((el) => {
        this.instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },

    filterFewLeftDays() {
      this.fewLeftDayMap = {}
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter((e) => e.stock > 0 && e.stock <= 4)
      const fewLeftDays = []
      vacancyCalendars.forEach((el) => {
        this.fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    },

    filterCloseDays() {
      this.outstockDayMap = {}
      const lastDay = moment(this.stayDay).endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          this.stayDay.month() + 1 > 9
            ? this.stayDay.month() + 1
            : `0${this.stayDay.month() + 1}`
        const day = `${this.stayDay.year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },

    calendarDisabledPrev() {
      const now = moment(new Date())
      return this.stayDay.isSameOrBefore(now, 'month')
    },

    menuPrice() {
      const data = (this.planList || []).reduce((acc, plan) => {
        const calendar = _.get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
          (item) => item.stayDay === this.currentDay
        )
        if (calendar) {
          return [...acc, calendar]
        }
        return acc
      }, [])

      const firstData = data[0] || {}
      const hasRoomPrice = firstData?.roomPrice !== null
      let minPrice = hasRoomPrice ? firstData?.roomPrice : firstData?.price || 0
      if (data.length) {
        data.forEach((item) => {
          const price = hasRoomPrice ? +item.roomPrice : +item.price
          if (minPrice >= price) minPrice = price
        })
      }

      return {
        price: minPrice,
        symbol: hasRoomPrice ? '円／室' : '円/人'
      }
    },

    menuCategoryTag() {
      let categoryTag = ''
      if (this.menuBasicInfo) {
        if (_.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
        } else if (_.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
        } else if (_.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
        }
      }
      return categoryTag
    },
    getPlanIcons(){
      return this.plan?.planIcons ? _.cloneDeep(this.plan.planIcons) : [];
    },
    /**
     * @return { Number } Google Map pin position adjustment (latitude)
     * @see {@link https://developers.google.com/maps/documentation/embed/embedding-map? hl=yes}
     */
    mapCenter () {
      return this.innerWidth > 640 ? 0.0006 : this.innerWidth > 440 ? 0.0013 : 0.0009
    },
    availableSubsidy() {
      this.dump('availableSubsidy called', this.subsidyList)
      return this.subsidyList && this.subsidyList.length > 0 && this.loggedIn;
    }
  },

  created() {
    const { menuNo } = this.$route.params
    // CLEAR FLOW DATA
    const menuStayParams = _.cloneDeep(_.get(this.$store.state.bs_app, 'bs_app.public_stay.stayParam', null))
    if(menuStayParams && menuStayParams.menuBasicInfo.menuNo != menuNo){
      const userInfo = _.cloneDeep(_.get(this.$store.state.bs_app, 'bs_app.userInfo', null))
      this.$store.commit('RESET_STATE')
      this.$store.commit('SET_INFO_USER', userInfo)
    }

    const { adultHeadCnt, checkInDate, stayNights } = this.$route.query
    this.numPeople = adultHeadCnt || 1
    if (checkInDate) {
      this.stayDay = moment(checkInDate)
      this.checkInDay = moment(checkInDate).clone().format('YYYY-MM-DD')
      this.checkOutDay = moment(checkInDate).add(stayNights || 1, 'days')
    }
    this.stayNights = stayNights || 1

    // this.getPlanList()
    // this.getVacancyCalendar()
  },

  async mounted() {
    await this.getMenuStayInfo()
    this.getEquipService()
    if (this.loggedIn) {
      this.getSubsidyCoupons()
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  watch: {
    // stayDay(val, old) {
      //   if (val && !val.isSame(old, 'month')) {
        //     this.$nextTick(() => {
          //       // this.getVacancyCalendar()
        //     })
      //   }
    // }
  },

  methods: {
    dev(msg){
      // alert(msg)
      console.log(msg)
    },
    dump(...args){
      console.log(...args)
    },
    clearOrderStoreData() {
      this.$store.commit('order/setMenuInfo', {})
      this.$store.commit('order/setSubsidyAvailables', {})
      this.$store.commit('order/setOrderPublicStay', {}) 
      this.$store.dispatch(SAVE_CUSTOMER_PLAN, null)
      this.$store.dispatch(SAVE_PLAN_DETAIL, null)
      this.$store.dispatch(SAVE_PUBLIC_STAY, null)
      this.$store.dispatch(SAVE_SELECTED_WEB_RADIO, null)
    },
    getNestedValue(obj, path, defaultValue) {
      return get(obj, path, defaultValue);
    },
    isShowParsonalUsedMaxCnt(subsidy) {
      return (
        subsidy.availableData.parsonalUsedMaxCnt > 0 &&
        subsidy.availableData.parsonalUsedMaxTotalAmt > 0
      )
    },
    openTaxLink(){
      let params = document.documentElement.lang === 'en' ?  'about_tax_en' : 'travel_about_tax_jp'
       window.open(
        `${this.domainTop}/otherPage?other_id=${params}`
      )
    },
    isShowUsedMaxCntInsurance01(subsidy) {
      return _.get(subsidy, 'availableData.parsonalUsedMaxCnt')
    },
    isShowUsedMaxTotalAmt(subsidy) {
      return _.get(subsidy, 'availableData.parsonalUsedMaxTotalAmt', null)
    },
    isShowRemainingAmtCntLabelInsur(subsidy) {
      return (
        _.get(subsidy, 'scrennDisplayItemList.remainingCountLabel') &&
        _.get(subsidy, 'scrennDisplayItemList.remainingAmountLabel')
      )
    },
    getRequestTypeCoupon(subsidy) {
      return _.get(subsidy, 'availableData.requestType')
    },
    getPlanId(){
      if (process.env.VUE_APP_PUBLIC_STAY_PLAN_ID == 'undefined') {
        return "0";
      }
      return process.env.VUE_APP_PUBLIC_STAY_PLAN_ID;
    },
    getEquipService() {
      const { menuNo } = this.$route.params
      this.$store.dispatch(GET_SERVICE_DETAIL, menuNo).then((data) => {
        if (data !== null) {
          this.dump('equip service', data)
          this.dataService = [data[0]]
          data.forEach((el1) => {
            const equipServDetail1 = _.get(el1, 'equipServDetail1', null)
            if (equipServDetail1) {
              equipServDetail1.forEach((el2) => {
                const equipServDetail2 = _.get(el2, 'equipServDetail2', null)
                if (equipServDetail2) {
                  equipServDetail2.forEach((el3) => {
                    const title = _.get(el3, 'equipServNm2', null)
                    const canUse = _.get(el3, 'equipServValue2', null)
                    if (title === '駐車場') {
                      if (canUse === '○') {
                        this.canUseParking = true
                      }
                    }
                    if (title === '無料送迎') {
                      if (canUse === '○') {
                        this.canUseFreeTransfer = true
                      }
                    }
                  })
                }
              })
              equipServDetail1.forEach((item) => {
                const equipServNm2 = _.get(item, 'equipServNm2', null)
                const equipServValue2 = _.get(item, 'equipServValue2', null)

                if (equipServNm2 === '駐車場' && equipServValue2 === '○') {
                  this.dump('equipServNm2', equipServNm2 === '将棋')
                  this.canUseParking = true
                }
                if (equipServNm2 === '無料送迎' && equipServValue2 === '○') {
                  this.canUseParking = true
                }
              })
            }
          })
        }
      })
    },
    async getMenuStayInfo() {
      const { menuNo } = this.$route.params
      this.dump('getMenuStayInfo called')
      const newDate = new Date().getTime()
      await this.$store.dispatch(GET_MENU_STAY, { menuNo }).then(
        (res) => {
          this.dump('getMenuStayInfo response', res)
          this.menuBasicInfo = res.menuBasicInfo
          const menuPublicDate = _.get(this.menuBasicInfo, 'menuRcEndDt', null) 
          if(menuPublicDate){
              this.isMenuPublicDate =  newDate > new Date(menuPublicDate).getTime() 
          }else{
            this.isMenuPublicDate = false
          }
          bus.$emit('noPuclicDate', this.isMenuPublicDate)
          this.catchCopy = _.get(this.menuBasicInfo, 'catchCopy', null)
          this.leadCopy = _.get(this.menuBasicInfo, 'leadCopy', null)
          this.menuInformation = res.menuInfomation
          this.latitude = _.get(this.menuBasicInfo, 'areaInfomation.latitude')
          this.longitude = _.get(this.menuBasicInfo, 'areaInfomation.longitude')
          this.menuImages = _.get(res, 'menuBasicInfo.menuImages', [])
          this.pblcBenefitsInfo = _.get(res, 'pblcBenefitsInfo', null)
          this.menuHashtags = _.get(res, 'menuHashtags', null)
          const dataItemOrder = {
            type: 'type-small',
            menu_id: _.get(res, 'menuBasicInfo.menuNo', ''),
            label: _.get(res, 'menuBasicInfo.categoryInfomation', ''),
            baseImg: _.get(res, 'menuBasicInfo.menuImages[0].imageUrl', null),
            title1: _.get(res, 'menuBasicInfo.menuNm', '')
          }
          this.$store.commit('order/setDataItemPublicStay', dataItemOrder)
          this.facilities = _.get(res, 'facilities.facilities[0]', null)
          if (this.facilities && this.facilities.zipCode) {
            this.zipCode = `${this.facilities.zipCode.substring(
              0,
              3
            )}-${this.facilities.zipCode.substring(3, 7)}`
          }
          this.getFacilities()
          this.getRecommendServices()
          this.isLoading=true;
        },
        (error) => {
          this.isMenuPublicDate = true
          bus.$emit('noPuclicDate', this.isMenuPublicDate)
          console.error('error menu detail 790', error)
          if (+error.status === 401) {
            this.errorType = 'publicStay'
            this.showModalError = true
          }
        }
      )
    },
    getFacilities() {
      this.$store
        .dispatch(GET_FACILITIES, {
          latitude: this.latitude,
          longitude: this.longitude,
          page: 1
        })
        .then(
          (result) => {
            this.dump('getFacilities response', result)
            if (result && Array.isArray(result)) {
              this.aroundServices = result
            }
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getRecommendServices() {
      const { catLrgClassCd, catMidClassCd, catSmlClassCd } = _.get(
        this.menuBasicInfo,
        'categoryInfomation',
        {}
      )
      this.$store
        .dispatch(GET_SAME_CATEGORY_MENUS, {
          catLrgClassCd,
          catMidClassCd,
          catSmlClassCd
        })
        .then((data) => {
          this.dump('getRecommendServices response', data)
          this.sameCategoryMenus = data
        })
    },

    checkDisabledDate($event) {
      const now = moment(new Date())
      return $event.isBefore(now, 'date')
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? _.cloneDeep(this.vacancyCalendar.vacancyCalendars)
          : []
      const instockDays = vacancyCalendars
        .filter((e) => e.stock > 4 || e.stock === 0)
        .map((el) => el.stayDay)
      return !$event.isBefore(now, 'date') &&
        instockDays.includes($event.format(this.dateFormat))
        ? '○'
        : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      let vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      vacancyCalendars = vacancyCalendars.filter(
        (e) => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD')
      )
      // return !$event.isBefore(now, 'date') ? `<span class="text">${vacancyCalendars.length ? vacancyCalendars[0].stock : null}</span>` : ''
      return !$event.isBefore(now, 'date')
        ? `<span class="text">${vacancyCalendars.length ? '△' : null}</span>`
        : ''
    },
    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      return !$event.isBefore(now, 'date') &&
        !inStockDays.includes($event.format(this.dateFormat))
        ? '×'
        : ''
    },

    scrollToMap() {
      this.$smoothScroll({
        scrollTo: this.$refs.googleMap,
        offset: -120
      })
    },
    openMap() {
      if (this.latitude && this.longitude) {
        window.open(`https://maps.google.com/?q=${this.latitude},${this.longitude}`)
      } else {
        window.open('https://maps.google.com')
      }
    },
    // gotoGallery() {
      //   const { menuNo } = this.$route.params
      //   const query = this.$route.query
      //   this.$router.push({ path: `/menus/${menuNo}/photo-gallery`, query })
    // },

    // ====== Plan Information======
    // async getPlanList() {
      //   const { menuNo } = this.$route.params
      //   const queryPlanDetail = {
        //     adultHeadCnt: this.numPeople
      //   }

      //   if (this.stayDay) {
        //     queryPlanDetail.checkInDay = moment(this.stayDay).format('YYYY/MM/DD')
      //   }

      //   if (this.checkOutDay) {
        //     queryPlanDetail.checkOutDay = moment(this.checkOutDay).format('YYYY/MM/DD')
      //   }
    //   const planIdList = await this.$repositories('plan').searchPlan(
        //     this.paginationPlan.page - 1,
        //     this.paginationPlan.size,
        //     menuNo
      //   )

      //   this.planList = []
      //   if (!Array.isArray(planIdList.plans) && planIdList.plans?.length) return
      //   if (planIdList.plans?.length > 3) planIdList.plans.length = 3
      //   this.paginationPlan.totalItems = planIdList.totalItems
      //   planIdList.plans.forEach((plan) => {
        //     // get plan details
        //     this.$repositories('plan')
          //       .getPlanDetail(menuNo, plan.planId, plan.roomId, queryPlanDetail)
          //       .then((response) => {
            //         response.roomBasicInfo.planId = response?.planBasicInfo?.planId
            //         response.roomBasicInfo.menuNo = response?.planBasicInfo?.menuNo
            //         this.planList.push(response)
          //       })
      //   })
    // },

    // isNewPlan(plan) {
      //   const planRcSttDt = _.get(plan, 'planBasicInfo.planRcSttDt', null)
      //   const today = moment()
      //   return !!(
        //     planRcSttDt &&
        //     moment(planRcSttDt).isValid() &&
        //     moment(planRcSttDt).isAfter(today.subtract(5, 'days'))
      //   )
    // },

    // breakfastFlag(plan) {
      //   const breakfastFlag = _.get(plan, 'planUsage.usageDetailStay.breakfastFlag', '')
      //   const dinnerFlag = _.get(plan, 'planUsage.usageDetailStay.dinnerFlag', '')
      //   if (breakfastFlag === '0' && dinnerFlag === '0') {
        //     return '朝食と夕食は含まれていません'
      //   } else if (breakfastFlag === '1' && dinnerFlag === '1') {
        //     return 'ディナーのみ'
      //   } else if (breakfastFlag === '1' && dinnerFlag === '0') {
        //     return '朝食のみ'
      //   } else if (breakfastFlag === '1' && dinnerFlag === '1') {
        //     return '朝食・夕食つき'
      //   } else {
        //     return false
      //   }
    // },

    // extSystemCd(plan) {
      //   return _.get(plan, 'menuInformation.extSystemCd', null) === 'RakutenT'
    // },

    // goToPlanList() {
      //   const { menuNo } = this.$route.params
      //   const { stayNights, checkInDate } = this.$route.query

      //   const query = {
        //     adultHeadCnt: this.numPeople
      //   }
    //   if (stayNights) query.stayNights = stayNights
      //   if (checkInDate) query.checkInDate = checkInDate

      //   this.$router.push({
        //     path: `/menus/${menuNo}/plans`,
        //     query
      //   })
    // },

    // ====== Calendar ======
    // async getVacancyCalendar() {
      //   const { menuNo } = this.$route.params
      //   const checkInDate = this.stayDay.clone().startOf('month').format('YYYY-MM-DD')
      //   const checkOutDate = this.stayDay.clone().endOf('month').format('YYYY-MM-DD')
      //   const response = await this.$repositories('menu').getVacancyCalendar({
        //     checkInDate,
        //     checkOutDate,
        //     menuNo
      //   })

      //   const dateAvailable = _.get(response, 'dateAvailable', {})

      //   this.vacancyCalendar = {
        //     vacancyCalendars: []
      //   }
    //   _.forEach(dateAvailable, (value, key) => {
        //     const data = {
          //       stayDay: moment(key).format(this.dateFormat),
          //       stock: value
        //     }
    //     this.vacancyCalendar.vacancyCalendars.push(data)
      //   })
    // },

    // onNextOrder() {
    //   this.$store.commit('order/setMenuInfo', this.menuBasicInfo)
    //   const query = this.$route.query
    //   this.$router.push({ path: 'register-rooms', query })
    // }

    // 補助金ダイアログを利用するために、
    // 補助金ダイアログが利用しているstoreの値を設定する
    // 国内宿泊は、planDetailの情報をstoreに保存しているが、
    // 公共ではプランの詳細情報が無いため、
    // planDetailのデータ構造に合わせつつ、補助金ダイアログで利用するもののみを
    // storeに保存する
    // -----------------------------------------------------
    // 補助金ダイアログで必要となるplanDetailのデータ構造
    // menuInformationは、menuBasicInfoの情報を利用する
    //      menuInformation.menuNo
    //      menuInformation.categoryInfomation.catLrgClassCd
    //      menuInformation.categoryInfomation.catMidClassCd
    //      menuInformation.categoryInfomation.catSmlClassCd
    //      menuInformation.areaInfomation.areaLrgClassCd
    //      menuInformation.areaInfomation.areaMidClassCd
    //      menuInformation.areaInfomation.areaSmlClassCd
    //      menuInformation.areaInfomation.areaDtlClassCd
    //      menuInformation.extSystemCd => 宿泊情報提供会社だが、公共は未設定とする※PeopleRelationShipで参照している
    // planBasicInfo.planId => システム設定値固定
    // planUsage.usageDetail.ticketExclusionFlag => true固定
    // planUsage.usageDetail.buppanExclusionFlag => false固定
    // planUsage.usageDetail.famiExclusionFlag => false固定
    // -----------------------------------------------------
    setPlanDetailStoreDataForApllyCoupon() {
      let data = {}
      data.menuInformation = {}
      data.menuInformation.menuNo = this.menuBasicInfo.menuNo
      data.menuInformation.categoryInfomation = this.menuBasicInfo.categoryInfomation
      data.menuInformation.areaInfomation = this.menuBasicInfo.areaInfomation
      data.menuInformation.extSystemCd = ''
      data.planBasicInfo = {}
      data.planBasicInfo.planId = this.getPlanId()
      data.planUsage = {}
      data.planUsage.usageDetail = {}
      data.planUsage.usageDetail.ticketExclusionFlag = true
      data.planUsage.usageDetail.buppanExclusionFlag = false
      data.planUsage.usageDetail.famiExclusionFlag = false
      this.dump('setPlanDetailStoreDataForApllyCoupon', data)
      this.$store.dispatch(SAVE_PLAN_DETAIL, data)
    },

    onNextOrder() {
      const loggedIn = this.$auth.loggedIn
      if (loggedIn) {
        this.dev("dev5-1 cleared order store data")
        this.clearOrderStoreData();
        this.dev("dev5-2")
        this.$store.commit('order/setMenuInfo', this.menuBasicInfo)
        const query = this.$route.params
        this.dump('onNextOrder query', query)
        try {
          // 後工程で利用する、補助金ダイアログを利用するための各種情報をstoreに保存
          this.dev("dev6")
          this.setPlanDetailStoreDataForApllyCoupon()
          // このメニューで利用可能な補助金をstoreに保存
          this.$store.commit('order/setSubsidyAvailables', this.subsidyList) 
          this.$router.push({ path: 'register-rooms', query })
        } catch (error) {
          this.$toasted.error(error?.message)
        }
      } else {
        this.setCurrentHref()
        window.location = `${process.env.VUE_APP_API_URL}/v1/stay/login`
      }
    },
    onResize() {
        this.innerWidth = window.innerWidth
    },
    
    /**
     * 国内宿泊同様、補助金リストをAPIより取得する
     * 特定の条件で取得したリストからフィルタする
     * ・枚数ゼロは除外nullは除外しない
     * ・金額ゼロは除外nullは除外しない
     */
    async getSubsidyCoupons() {
      this.dump('getSubsidyCoupons called')
      const today = moment().startOf('days') // 日付比較のため.startOf('days')で時間設定を00:00:00にする

      // チェックイン、チェックアウトの概念はこの段階では設定できない。
      /**
       * TODO: 移植時の名残、コメントアウト、削除予定
       */
      // const stayNights = this.stayNights || 1
      // // stayDay
      // const checkInDay = this.getDataMoment(this.tmpVariables.stayDay, this.stayDay)
      // const checkOutDay =
      //   stayNights >= 0
      //     ? checkInDay.clone().add(stayNights, 'days')
      //     : checkInDay.clone().add(1, 'days')

      // couponシステムから補助金リスト取得(/sbsd/available)
      let subsidyAvailables = await this.$repositories('coupon')
        .getSubsidyCouponList({
          // reserveDateFrom: today.format('YYYY-MM-DD'),
          // reserveDateTo: today.format('YYYY-MM-DD'),
          // useDateFrom: checkInDay.format('YYYY-MM-DD'),
          // useDateTo: checkOutDay.format('YYYY-MM-DD'),
          personAccompanyFlag: null,
          displayDiv: '2'
        })
        .catch((error) => {
          return error
        })
      this.dump('subsidyAvailables1', subsidyAvailables)
      if (!subsidyAvailables || !Array.isArray(subsidyAvailables)) {
        subsidyAvailables = []
      }
      
      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      subsidyAvailables = subsidyAvailables.filter(data => data.availableRemainingCount !== 0);
      this.dump('subsidyAvailables2 filtered remainning count zero', subsidyAvailables)
      
      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      subsidyAvailables = subsidyAvailables.filter(data => data.availableRemainingAmount !== 0);
      this.dump('subsidyAvailables3 filtered remainning amount zero', subsidyAvailables)

      // 日付系期限チェック「受付期間」「適用期間」
      subsidyAvailables = subsidyAvailables.filter(
        (s) => {
          // 受付期間チェック
          const receptionCheck = moment(s.availableData.receptionDateFrom).isSameOrBefore(today) &&
            moment(s.availableData.receptionDateTo).isSameOrAfter(today);
          // const start = moment(s.availableData.applicableDateFrom);
          // const end = moment(s.availableData.applicableDateTo);
          // const lastNight = checkOutDay.clone().add(-1, 'days');
          // const checkInDayCheck = checkInDay.isBetween(start, end, 'day', '[]');
          // const checkOutDayCheck = lastNight.isBetween(start, end, 'day', '[]');
          // const startCheck = start.isBetween(checkInDay, checkOutDay, 'day', '[)');
          // const endCheck = end.isBetween(checkInDay, checkOutDay, 'day', '[)');
          // const limit = this.checkWithinLimApplicableDate(s.availableData.priceList, checkInDay, checkOutDay);
          // return receptionCheck && (checkInDayCheck || checkOutDayCheck || startCheck || endCheck) && limit;
          return receptionCheck;
        }
      )
      // this.dump('subsidyAvailables4 filterd check reception', subsidyAvailables)
      // ĐẶT TRƯỚC 7 NGÀY ĐỐI VỚI COUPON BẢO HIỂM
      // if (!moment().add(7, 'days').isSameOrBefore(this.tmpVariables.stayDay, 'day')) {
      //   subsidyAvailables = subsidyAvailables.filter(
      //     (s) => s.availableData.fiveDaysAgoControlFlg === "0"
      //   )
      // }

      // フィルタした結果、ステーションマッピングで
      // 残った補助金が果たしてこのメニュープランで使えるかどうかを判断する
      this.dump('subsidyAvailables', subsidyAvailables);
      this.dump('menuBasicInfo', this.menuBasicInfo);
      if (subsidyAvailables.length) {
        const subsidyIds = subsidyAvailables
        .map((s) => s.availableData.subsidyId)
        .join('-')
        const { catLrgClassCd, catMidClassCd, catSmlClassCd } = _.get(
        this.menuBasicInfo,
        'categoryInfomation',
        {}
        )
        const { areaLrgClassCd, areaMidClassCd, areaSmlClassCd, areaDtlClassCd } = _.get(
        this.menuBasicInfo,
        'areaInfomation',
        {}
        )
        const menuNo = _.get(this.menuBasicInfo, 'menuNo', "")
        const params = {
          id: subsidyIds, // 0: subsidy, 1: cafe
          targetType: 0, // 0: subsidy, 1: cafe
          catLrgClassCd: catLrgClassCd,
          catMidClassCd: catMidClassCd,
          catSmlClassCd: catSmlClassCd,
          menuNo: menuNo,
          planId: '0',
          areaLrgClassCd: areaLrgClassCd,
          areaMidClassCd: areaMidClassCd,
          areaSmlClassCd: areaSmlClassCd,
          areaDtlClassCd: areaDtlClassCd,
          receivableFlag: '1',
          ticketExclusionFlag: '1',
          buppanExclusionFlag: '1',
          famiExclusionFlag: '1',
        }
        const stationMapping = await this.$repositories('coupon')
        .getStationMapping(params)
        .catch((error) => {
        return error
        })
        this.dump('stationMapping', stationMapping) 

        if (stationMapping && stationMapping.bsSubsidyMappingArray) {
        const bsSubsidyIdMappings = stationMapping.bsSubsidyMappingArray.map(
        (e) => e.subsidyId
        )
          subsidyAvailables = subsidyAvailables.filter((c) =>
        bsSubsidyIdMappings.includes(c.availableData.subsidyId)
        )
        }else {
        // ステマAPI実行時にエラーが発生した場合、補助金情報を返さない #77940
          subsidyAvailables = []
        }
        this.dump('subsidyAvailables5 filterd station mapping', subsidyAvailables)


        const subsidyList = subsidyAvailables
          .filter(
            (c) => {
              this.dump('subsidyAvailables6 filterd useStopFlg rec', c.availableData.useStopFlg
                , c.availableData.subsidyType
                , c.availableRemainingCount
                , c.availableRemainingAmount)
              let check = (
              +c.availableData.useStopFlg === 0 &&
              c.availableData.subsidyType === '01' &&
              (c.availableRemainingCount === null || +c.availableRemainingCount > 0) &&
              (c.availableRemainingAmount === null || +c.availableRemainingAmount > 0))
              this.dump('subsidyAvailables6 filterd useStopFlg rec check', check)
              return check
            }
          )
          .map((s) => {
            if (Array.isArray(s.availableData.priceList)) {
              // find coupons owner
              const priceList = s.availableData.priceList.filter(
                (e) => e.priceType === COUPON_PRICE_TYPE.OWNER
              )
              if (priceList.length) {
                s['listPrice'] = priceList
              } else if (s.availableData.priceList.length) {
                s['listPrice'] = s.availableData.priceList
              }
            }
            return s
          })
        this.dump('subsidyAvailables6 filterd useStopFlg', subsidyList)
        this.subsidyList = subsidyList.filter((s) => s.listPrice)

        // 受付期間のToが早い順にする
        this.subsidyList.sort((a, b) => {
          return new Date(a.availableData.receptionDateTo) - new Date(b.availableData.receptionDateTo)
        })

        this.subsidyCouponList = this.subsidyList.filter(subsidy => subsidy.availableData.groupInfo == null)
        this.subsidyCouponGroupList = this.subsidyList.filter(subsidy => subsidy.availableData.groupInfo != null)
                                        .sort((prev, next) => {
                                          // グループidごとに昇順でソート(ソート順で要望は決まってないため昇順に設定)
                                          if (prev.availableData.groupInfo.groupId !== next.availableData.groupInfo.groupId) {
                                            if (prev.availableData.groupInfo.groupId > next.availableData.groupInfo.groupId)
                                              return 1;
                                            if (prev.availableData.groupInfo.groupId < next.availableData.groupInfo.groupId)
                                              return -1;
                                          }
                                        })
        // グループ補助金情報を先頭表示判別のためのフラグを追加
        let groupId = '';
        let firstGroupId = '';
        this.subsidyCouponGroupList.forEach((val, idx) => {
          val.displayGroupInfoFlg = false;
          if (val.availableData.groupInfo.groupId != groupId) {
            val.displayGroupInfoFlg = true;
            groupId = val.availableData.groupInfo.groupId;
          }
          if (idx == 0) { firstGroupId = val.availableData.groupInfo.groupId;}
          if (firstGroupId == val.availableData.groupInfo.groupId) {
            val.dispFlag = true;
          } else {
            val.dispFlag = false;
          }
        })
        // グループ情報のみを抽出
        this.subsidyGroupList = this.subsidyCouponGroupList.map((subsidy) => { return subsidy.availableData.groupInfo })
        this.subsidyGroupList = this.subsidyGroupList.filter(
          (element, index, group) => group.findIndex((e) => e.groupId === element.groupId) === index
        )

        // this.getSubsidyIcon(this.subsidyList);
      }
    },
    infoGroupTexts(subsidy) {
      let message = [];

      // 利用制限期間
      if (subsidy.availableData.groupInfo.usedLimTerm === "01") {
        message.push("上記適用期間内での制限適用となります");
      } else {
        message.push("月の利用制限となります");
      }

      // 利用上限総額（数）
      if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`);
      } else if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        !subsidy.availableData.groupInfo.usedMaxTotalAmt
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで`);
      } else if (
        !subsidy.availableData.groupInfo.usedMaxCnt &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push("※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。");
      }

      return message.join('/');
    },
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.no-data {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 30px;
  }
}
</style>
